export default __webpack_public_path__ + "e183927f8637e5e411f809c8de3da79f.svg";